module.exports = __webpack_public_path__ + "static/media/instagram-logo.9ce5bb4f.svg";